import React, { Component } from 'react'
import { CSSTransition } from 'react-transition-group'
import { connect } from 'react-redux'
import { getLanguageKeys } from '@/store/getters'

import styles from './styles.scss'

/** Components */
import Button from '@/components/Button'


class Modal extends Component {

  handleKeyDown = (event) => {
    if (event.key === 'Escape')
      return this.props.handleClose()
    else if (event.key === 'Enter') {
      return this.props.handleAccept()
    }
  }

  render() {
    const { locales, handleAccept, handleClose, defaultButtons, show, children, style } = this.props

    return (
      <CSSTransition
        in={show}
        timeout={300}
        classNames="fade-in"
        unmountOnExit
      >
        <div className={`ba-flex ba-jc-center ba-ai-center ${styles['wrapper-modal']}`} style={style}  >
          <section
            className={`${styles['wrapper-modal__content']}`}
            onKeyDown={this.handleKeyDown}
          >

            {children}
            {
              defaultButtons &&
              <div className={styles['wrapper-modal__options']}>
                <Button
                  color="light"
                  size="large"
                  onClick={handleClose}
                >
                  {locales['general-cancel']}
                </Button>
                <Button
                  size="large"
                  onClick={handleAccept}
                >
                  {locales['general-confirm']}
                </Button>
              </div>
            }
          </section>
        </div>
      </CSSTransition>
    )
  }
}

const mapStatesToProps = state => {
  const locales = getLanguageKeys(state)
  return {
    locales,
  }
}
export default connect(
  mapStatesToProps,
)(Modal)


// WEBPACK FOOTER //
// ./src/components/Modal/index.js